<template>
  <bpb-picture
    :src="defaultSource.url"
    alt=""
    :sources="formattedSources"
    :source-selector="forProductExtension ? 'size-orientation' : 'size'"
    :select-size-by="forProductExtension ? 'auto' : 'width'"
    :copy-size-by="forProductExtension ? '.teaser-shop__picture' : undefined"
  ></bpb-picture>
</template>

<script>
import sortBy from 'lodash/sortBy';

export default {
  props: {
    alt: {
      type: String,
    },
    sources: {
      type: Array,
      required: true,
    },
    forProductExtension: {
      type: Boolean,
    },
  },
  computed: {
    defaultSource() {
      const sourcesSorted = sortBy(this.sources, value => value.width);
      return sourcesSorted[sourcesSorted.length - 1];
    },
    formattedSources() {
      return (
        this.sources
          // .filter(source => {
          //   return source.minWidth !== 0;
          // })
          .map(source => {
            return {
              srcset: source.url,
              width: source.width,
              height: source.height,
              // media: `(min-width: ${source.minWidth}px)`,
            };
          })
      );
    },
  },
};
</script>
